// extracted by mini-css-extract-plugin
module.exports = {"big":"Spinner_big__2-MEW"};